export default __webpack_public_path__ + "static/media/cs-block-3.f8ef5899.png";